import { useCallback } from "react";
import { type CubePage, pageScope } from "./useCubeSelectionState";
import type { useFetchVersions } from "./useFetchVersions";
import { useOpenOnce } from "./useOpenOnce";

/**
 * A fresh session opens a page on the planner's main cube — the one sane
 * default for what to load. Only on open: clearing it and coming back must
 * not re-select it. Budget pages have no "own" cube, so they pass
 * ``enabled: false`` and open blank. The write is the page's: the temporal
 * grid sets a version option, the summary a producer and a version.
 */
export function useOpenOnMainCube(
  page: CubePage,
  enabled: boolean,
  versionsData: ReturnType<typeof useFetchVersions>["data"],
  select: (cubeId: string) => void
) {
  const selectMainCube = useCallback(() => {
    const main = versionsData?.user_versions?.find(
      (version) => version.is_main
    );
    if (main) select(main.cube_id);
  }, [versionsData, select]);
  useOpenOnce(
    pageScope(page),
    "mainCube",
    enabled && versionsData !== undefined,
    selectMainCube
  );
}
